<template>
    <div style="position:fixed;color: #fff">
      <p  v-for="i in json">{{i}}</p>
    </div>
</template>

<script>
  // let ws = new WebSocket("ws://192.168.1.11:8090/websocketTest/websocket/echo");
    export default {
        name: "test",
        data() {
            return {
              ws:ws,
              json:[]
            }
        },
        methods: {

          onmessage(){
            // let _this=this
            // this.ws.onopen=function () {
            //
            // }
            // this.ws.onmessage = function (evt) {
            //
            //   let json = JSON.parse(evt.data)
            //
            //   var s = json.eventTime;
            //
            //   s = s.replace(/-/g, "/");
            //   var date = new Date(s);
            //   let Y = date.getFullYear();
            //   let M = ((date.getMonth() + 1) > 10 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1));
            //   let D = (date.getDate() >= 10 ? date.getDate() : '0' + date.getDate());
            //   let H = ((date.getHours() + 8) >= 10 ? (date.getHours() + 8) : '0' + (date.getHours() + 8));
            //   let N = (date.getMinutes() >= 10 ? date.getMinutes() : '0' + date.getMinutes());
            //   let S = (date.getSeconds() >= 10 ? date.getSeconds() : '0' + date.getSeconds());
            //   let toDay = Y + '-' + M + '-' + D + " " + H + ":" + N + ":" + S;
            //
            //   _this.json.push(toDay)
            // }
            // this.ws.onclose = function(){
            //   // 关闭 websocket
            //   console.log("连接已关闭...");
            // };
            }

        },

        mounted() {
          // this.onmessage()
        },
        beforeMount() {
        },
        beforeCreate() {

        },
        beforeDestroy() {

        },
        beforeUpdate() {

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/test/test.vue